export const OCPP_API_ENDPOINTS = {
  All_SESSIONS_PATH: '/sessions/all',
  CALCULATE_PATH: '/calculate',
  DASHBOARD_STATIONS_PATH: '/dashboard/stations',
  DASHBOARD_STATS_PATH: '/dashboard/stats',
  DASHBOARD_KWH_PER_DAY_PATH: '/dashboard/kwh-per-day',
  DASHBOARD_STATIONS_LIST_PATH: '/dashboard/stations-list',
  GET_DISCOUNT_USER_METRICS_PATH: '/discounts/my/metrics',
  ORGANIZATIONS_PATH: '/organizations',
  PAYMENTS_PATH: '/ocpp/invoice',
  SESSION_PATH: '/sessions/my/active',
  SESSIONS_PATH: '/sessions',
  SESSION_METRICS_PATH: '/sessions',
  START_TRANSACTION_WITHOUT_PAYMENTS_PATH:
    '/ocpp/remoteStartTransactionWithoutPayments',
  STATION_CREATE_PATH: '/stations',
  STATION_LOCATIONS_BY_SEARCH__PATH: '/stations/locations-by-search',
  STATION_LOCATIONS_PATH: '/stations/locations',
  STATION_PATH: '/stations',
  STATION_REQUEST_CREATE_PATH: '/station-requests',
  STATION_REQUESTS_ADMIN_PATH: '/station-requests',
  STOP_TRANSACTION_PATH: '/ocpp/stopTransaction',
  CHANGE_AVAILABILITY_PATH: '/ocpp/changeAvailability',
  GET_CONFIGURATION_PATH: '/ocpp/getConfiguration',
  MANUAL_SENDING_PATH: '/ocpp/manualSending',
  SET_CHARGING_PROFILE_LIMIT_PATH: '/ocpp/setChargingProfileLimit',
  TRANSACTIONS_PATH: '/transactions',
  USER_LAST_SESSION_PATH: '/sessions/my/last',
  INVOICE_STATUS_PATH: '/payments/invoices/status',
};
